import { APP_INITIALIZER, inject, NgModule, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import Material from '@primeuix/themes/material';
import { AuthService } from './shared/auth/auth.service';
import { providePrimeNG } from 'primeng/config';
import { definePreset, palette } from '@primeuix/themes';
import type { ColorScale } from '@primeuix/styled';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { MaterialModule } from '@modules/material.module';
import { ConciliacaoModule } from './pages/financeiro/conciliacao/conciliacao.module';
import { AuthModule } from './shared/auth/auth.module';
import { HttpAuthErrorInterceptor } from '@interceptors/http-auth-error.interceptor';
import { FileSizeInterceptor } from '@interceptors/file-size.interceptor';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { HistoricoConciliacaoModule } from './pages/financeiro/historico-conciliacao/historico-conciliacoes.module';
import { MovimentacaoCaixaModule } from './pages/financeiro/movimentacao-caixa/movimentacao-caixa.module';
import { PainelFinanceiroModule } from './pages/financeiro/painel-financeiro/painel-financeiro.module';
import { ConfiguracaoCaixaModule } from './pages/financeiro/configuracao-caixa/configuracao-caixa.module';
import { ConfigurarRelatorioCaixaModule } from './pages/financeiro/configurar-relatorio-caixa/configurar-relatorio-caixa.module';
import { LoginModule } from './pages/autenticacao/login/login.module';
import { RelatorioFinanceiroModule } from './pages/financeiro/relatorio-financeiro/relatorio-financeiro.module';
import { GerenciarPerfisUsuariosModule } from './pages/autenticacao/gerenciar-perfis-usuarios/gerenciar-perfis-usuarios.module';
import { DadosContaModule } from './pages/autenticacao/dados-conta/dados-conta.module';
import { CadastroLoteLancamentosModule } from './pages/financeiro/cadastro-lote-lancamentos/cadastro-lote-lancamentos.module';
import { RegraConciliacaoAutomaticaModule } from './pages/financeiro/regra-conciliacao-automatica/regra-conciliacao-automatica.module';
import { ListarModelosVistoriaModule } from './pages/vistoria/listar-modelos-vistoria/listar-modelos-vistoria.module';
import { EditarModeloVistoriaModule } from './pages/vistoria/editar-modelo-vistoria/editar-modelo-vistoria.module';
import { TemplateModeloVistoriaModule } from './pages/vistoria/template-modelo-vistoria/template-modelo-vistoria.module';
import { RealizarVistoriaModule } from './pages/vistoria/realizar-vistoria/realizar-vistoria.module';
import { ListarVistoriasModule } from './pages/vistoria/listar-vistorias/listar-vistorias.module';
import { TelaInicialModule } from './pages/inicio/tela-inicial.module';

const CustomPalette = definePreset(Material, {
  semantic: {
    primary: palette('{green}') as ColorScale
  }
})

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AuthModule,
    AppRoutingModule,
    SharedModule,
    MaterialModule,
    ConciliacaoModule,
    PainelFinanceiroModule,
    HistoricoConciliacaoModule,
    MovimentacaoCaixaModule,
    CadastroLoteLancamentosModule,
    ConfiguracaoCaixaModule,
    ConfigurarRelatorioCaixaModule,
    RegraConciliacaoAutomaticaModule,
    LoginModule,
    RelatorioFinanceiroModule,
    GerenciarPerfisUsuariosModule,
    DadosContaModule,
    ListarModelosVistoriaModule,
    EditarModeloVistoriaModule,
    TemplateModeloVistoriaModule,
    RealizarVistoriaModule,
    ListarVistoriasModule,
    TelaInicialModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: FileSizeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpAuthErrorInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.initializeAuth();
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomPalette,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme'
        }
      },
      ripple: true
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
